<template>
  <div>
    <div class="bg-white height-50 pt-15 text-align-center flex flex-space-around flex-wrap">
        <van-button plain color="#008c8c" @click="confirm('leftText')">{{leftText}}</van-button>
        <van-button color="#008c8c" @click="confirm('rightText')">{{rightText}}</van-button>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props:{
    leftText: { type: String, required: false, default: '返回首页'}, // 左边按钮文字
    rightText: { type: String, required: false, default: '添加人员'}, // 右边按钮文字
  },
  data() {
    return {
    };
  },
  methods: {
    confirm(val){
        this.$emit('click', val);
    }

  },
};
</script>

<style>
</style>